<template>
    <v-container fluid style=""> 
    
            <v-form ref="filterForm">
              <v-row style="width:100%; margin: 0;">
                <v-col cols="6">
                    <v-select
                        v-model="currentMode"
                        :label="'Mode'" 
                        :items="optionModes"
                    />
                </v-col>
                <v-col cols="6">
                    <v-select
                        v-model="editOption.type"
                        :label="'Type'" 
                        :items="currentOptionTypes"
                    />
                </v-col>
                <v-col cols="6" v-if="editOption.type=='DIALOG_BUILDER'">
                    <v-text-field
                        v-model="editOption.dialogId"
                        :label="'Dialog Id'" 
                        autocomplete="none"
                        max="5"
                    />
                </v-col>
                <v-col cols="6">
                    <v-select
                        v-model="editOption.action"
                        :label="'Action'" 
                        :items="optionActions"
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-model="editOption.payload"
                        autocomplete="none"
                        :label="'Payload'" 
                        max="50"
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-model="editOption.label"
                        :label="'Label'" 
                        autocomplete="none"
                        max="200"
                    />
                </v-col>
            </v-row>
            </v-form>

     </v-container>
 </template>
 
 <script> 
 
 import BaseModule from '../../../common/BaseModule.js'
 import { Constants } from '../../../common/Constants'

 export default {
   name: 'EventEditor',
   mixins: [BaseModule],
   components: { 
    
   },
    props: ['option'],
   
   data() {
       return { 
         editOption: {},
         tableHeight:300,
         optionModes:[],
         optionTypes:{},
         optionActions:[],
         currentMode: null,
       }
   }, mounted() {
        this.editOption = this.option?this.option:{};
        this.optionModes = Constants.eventModes;
        this.optionTypes = Constants.eventTypes;
        this.optionActions = Constants.eventActions;
        this.currentMode = this.editOption.mode;
    },watch: {
       context: function() { 
        
      },
      option: function(option) { 
        this.editOption = option?option:{};
        this.currentMode = this.editOption.mode;
        }
     },
     computed: {
        // a computed getter
        currentOptionTypes() {
        if (!this.currentMode) {
            return [];
        }
        return this.optionTypes[this.currentMode];
      }
    },
    methods: { 
       getValue() {
           this.editOption.mode=this.currentMode;
           return this.editOption;
       }
    }
 };
 </script>
  